import { useTranslation } from "react-i18next";

import { useCompanyLevelSettings } from "shared/hooks/useCompanyLevelSettings";
import { COLUMN_IDENTIFIERS, COMPANY_LEVEL_SETTINGS } from "shared/types/enums";

import { InfoTooltip } from "../InfoTooltip";
import { HeadTitleInfoProps } from "../types";
import ConfigurationTypeInfo from "./ConfigurationTypeInfo";
import PlatformInfo from "./PlatformInfo";
import VisibilityInfo from "./VisibilityInfo";

const HeadTitleInfo = ({
    restriction,
    columnWithAdditionalInfo,
    ...props
}: HeadTitleInfoProps) => {
    const { t } = useTranslation();
    const { isFeatureSettingsRestricted } = useCompanyLevelSettings();

    const isRestricted = isFeatureSettingsRestricted(restriction);

    const getAdditionalInfo = (column: COLUMN_IDENTIFIERS) => {
        switch (column) {
            case COLUMN_IDENTIFIERS.DevicesModelPlatform:
            case COLUMN_IDENTIFIERS.ModelsModelPlatform:
                return <PlatformInfo />;
            case COLUMN_IDENTIFIERS.Visibility:
                return <VisibilityInfo />;
            case COLUMN_IDENTIFIERS.ConfigurationType:
                return <ConfigurationTypeInfo />;
            case COLUMN_IDENTIFIERS.UserSentConfiguration:
                return (
                    <>
                        {t(
                            "Table##head title info##auto synced##user sent configuration"
                        )}
                    </>
                );
            case COLUMN_IDENTIFIERS.SyncedAt:
                return (
                    <>{t("Table##head title info##auto synced##synced at")}</>
                );
            case COLUMN_IDENTIFIERS.ConfigurationChangesChangedAt:
                return (
                    <>{t("Table##head title info##auto synced##changed at")}</>
                );
            case COLUMN_IDENTIFIERS.ConfigurationChangesDownloadAt:
                return (
                    <>{t("Table##head title info##auto synced##download at")}</>
                );
            default:
                return "";
        }
    };

    const getTitle = () => {
        if (isRestricted) {
            return t(
                `Restrictions##${COMPANY_LEVEL_SETTINGS.FeatureSettings}##${restriction}##table head`
            );
        }

        if (columnWithAdditionalInfo) {
            return getAdditionalInfo(columnWithAdditionalInfo);
        }

        return "";
    };

    return getTitle() ? <InfoTooltip {...props} title={getTitle()} /> : null;
};

export { HeadTitleInfo };
